<app-page-header class="document-header">

  <div class="document-header__wrapper">

    <!-- =========================
         TOP HEADER
    ========================== -->
    <div class="document-header__top">

      <!-- Back -->
      <button type="button" class="back-button" (click)="navigateBack()" aria-label="Back to document">

        <i class="pi pi-angle-left"></i>

        <span class="back-text desktop-only">
          Back To Document
        </span>

        <!-- <span class="back-text mobile-only">
          Back
        </span> -->

      </button>


      <!-- Document information -->
      <div class="document-info">

        <!-- <div class="document-title" [title]="document_title">

          <i class="pi pi-file document-title__icon"></i>

          <span>
            {{ document_title }}
          </span>

        </div> -->


        <!-- Query mode -->
        <div class="query-switch">

          <label class="query-option" [class.active]="assistBotService.queryType['library']">

            <input type="radio" name="queryType" value="private" [checked]="assistBotService.queryType['library']"
              (change)="changeQuery($event)" />

            <span class="query-radio"></span>

            <span class="query-content">
              <span class="query-label">
                Private
              </span>

              <span class="query-description">
                Based on this document
              </span>
            </span>

          </label>


          <label class="query-option" [class.active]="!assistBotService.queryType['library']">

            <input type="radio" name="queryType" value="generic" [checked]="!assistBotService.queryType['library']"
              (change)="changeQuery($event)" />

            <span class="query-radio"></span>

            <span class="query-content">
              <span class="query-label">
                Generic
              </span>

              <span class="query-description">
                Based on public data
              </span>
            </span>

          </label>

        </div>

      </div>


      <!-- Header actions -->
      <div class="header-actions">

        <button type="button" class="header-action" [class.active]="activeTab === 'history'"
          (click)="openDocumentpopup('history')" pTooltip="history" tooltipPosition="bottom"  placeholder="Bottom"  >

          <i class="pi pi-history"></i>

          <!-- <span>History</span> -->

        </button>


        <button type="button" class="header-action" [class.active]="activeTab === 'pin'"
          (click)="openDocumentpopup('pin')" pTooltip="Pin" tooltipPosition="bottom"  placeholder="Bottom"  >

          <i class="pi pi-thumbtack"></i>

          <!-- <span>Pin</span> -->

        </button>

<!--
        <button type="button" class="header-action" [class.active]="activeTab === 'audio'"
          (click)="openDocumentpopup('audio')"  pTooltip="Audio" tooltipPosition="bottom"  placeholder="Bottom" >

          <i class="pi pi-headphones"></i>

        </button> -->


        <button type="button" class="header-action" [class.active]="activeTab === 'document'"
          (click)="openDocumentpopup('document')" pTooltip="Document" tooltipPosition="bottom"  placeholder="Bottom" >

          <i class="pi pi-file"></i>

          <!-- <span>Document</span> -->

        </button>

      </div>

    </div>


    <!-- =========================
         MOBILE QUERY SWITCH
    ========================== -->
    <div class="mobile-query-switch">

      <div class="query-switch">

        <label class="query-option" [class.active]="assistBotService.queryType['library']">

          <input type="radio" name="mobileQueryType" value="private" [checked]="assistBotService.queryType['library']"
            (change)="changeQuery($event)" />

          <span class="query-radio"></span>

          <span class="query-label">
            Private
          </span>

        </label>


        <label class="query-option" [class.active]="!assistBotService.queryType['library']">

          <input type="radio" name="mobileQueryType" value="generic" [checked]="!assistBotService.queryType['library']"
            (change)="changeQuery($event)" />

          <span class="query-radio"></span>

          <span class="query-label">
            Generic
          </span>

        </label>

      </div>

    </div>

  </div>

</app-page-header>


<!-- Right Sidebar Panel -->
<div class="right-sidebar" [class.open]="isSidebarOpen">
  <button class="close-btn" (click)="toggleAISidebar()">×</button>
  <!-- Sidebar content goes here -->
  <!-- Tabs -->
  <ul class="tab-list">
    <li [class.active]="activeTab === 'history'" (click)="activeTab = 'history'" class="has-tooltip-left"
      data-tooltip="History" data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Tooltip on left"
      class="has-tooltip-left" placement="left"><i class="fa fa-history" aria-hidden="true"></i></li>
    <li [class.active]="activeTab === 'pin'" (click)="activeTab = 'pin'" class="has-tooltip-left" data-tooltip="Pin"
      data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Tooltip on left" class="has-tooltip-left"
      placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></li>
    <li [class.active]="activeTab === 'document'" (click)="activeTab = 'document'" class="has-tooltip-left"
      data-tooltip="Document" data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Tooltip on left"
      class="has-tooltip-left" placement="left"><i class="fa fa-file-text-o" aria-hidden="true"></i></li>
    <li [class.active]="activeTab === 'audio'" (click)="activeTab = 'audio'" class="has-tooltip-left"
      data-tooltip="Audio" data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Tooltip on left"
      class="has-tooltip-left" placement="left"><i class="fa fa-headphones" aria-hidden="true"></i></li>
  </ul>


  <div class="tab-content">

    <ng-container *ngIf="activeTab === 'history'">
      <div class="col-md-4 px-0 left-box-shadow tab-view">

        <div class="menu-options level is-marginless searchBox-pad display-flex pe-2">
          <div class="level-left">
            <div class="level-item input-search-box">
              <div class="field">
                <p class="control has-icons-left has-icons-right">
                  <input class="input" type="text" placeholder="Search" inputFocus [(ngModel)]="search"
                    (keyup.enter)="getChatList(0)" placeholder="Search here...">

                  <a class="icon is-small is-left" title="Search">
                    <i class="fa fa-search"></i>
                  </a>
                  <!-- <span class="input-bar"></span> -->
                </p>
              </div>
            </div>
            <div class="level-item" *ngIf="search !==''">
              <span class="icon is-small is-right search-return" (click)="showSearchbox('close')">
                <i class="fa fa-times-circle"></i>
              </span>
            </div>
          </div>


        </div>
        <div class="listing-data">
          <ul *ngIf="chatHistoryList.length > 0">
            <li *ngFor="let historydata of filterChat(chatHistoryList); let i = index; let odd = odd">


              <ng-container *ngIf="historydata.question">

                <div class="history-item" [ngClass]="{ 'odd': odd }">

                  <label (click)="gotoHistory(historydata?.sequence_id)" class="history-label">
                    <i class="fa fa-commenting" aria-hidden="true"></i>
                    {{ historydata.question }}
                  </label>


                  <a class="history-delete" title="Delete" (click)="removeHistory(historydata?.history_id)">
                    <i class="pi pi-trash" aria-hidden="true"></i>
                  </a>
                </div>

              </ng-container>

            </li>
          </ul>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="activeTab === 'pin'">
      <div class="col-md-4 px-0 left-box-shadow tab-view">
        <div class="menu-options level is-marginless searchBox-pad display-flex">
          <div class="level-left">
            <div class="level-item input-search-box">
              <div class="field">
                <p class="control has-icons-left has-icons-right">
                  <input class="input" type="text" placeholder="Search" [(ngModel)]="search"
                    (keyup.enter)="getChatList(0)" placeholder="Search here...">

                  <a class="icon is-small is-left" title="Search">
                    <i class="fa fa-search"></i>
                  </a>
                  <!-- <span class="input-bar"></span> -->
                </p>
              </div>
            </div>
            <div class="level-item" *ngIf="search !==''">
              <span class="icon is-small is-right search-return" (click)="showSearchbox('close')">
                <i class="fa fa-times-circle"></i>
              </span>
            </div>
          </div>


        </div>
        <div class="listing-data">
          <ul *ngIf="chatPinList.length > 0">
            <li *ngFor="let historydata of filterChat(chatPinList); let i = index; let odd = odd">
              <ng-container *ngIf="historydata.question">

                <div class="pin-item" [ngClass]="{ 'odd': odd }">

                  <label class="pin-label" (click)="gotoHistory(historydata?.sequence_id)">
                    <i class="fa fa-thumb-tack" aria-hidden="true"></i>
                    {{ historydata.question }}
                  </label>


                  <a class="pin-delete" title="Delete" (click)="removePin(historydata?.history_id)">
                    <i class="pi pi-trash" aria-hidden="true"></i>
                  </a>
                </div>

              </ng-container>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="activeTab === 'document'">
      <div class="col-md-4 px-0 left-box-shadow tab-view">
        <div class="menu-options level is-marginless searchBox-pad display-flex">
          <div class="level-left">
            <div class="level-item input-search-box">
              <div class="field">
                <p class="control has-icons-left has-icons-right">
                  <input class="input" type="text" placeholder="Search" [(ngModel)]="search"
                    (keyup.enter)="getChatList(0)" placeholder="Search here...">

                  <a class="icon is-small is-left" title="Search">
                    <i class="fa fa-search"></i>
                  </a>
                  <!-- <span class="input-bar"></span> -->
                </p>
              </div>
            </div>
            <div class="level-item" *ngIf="search !==''">
              <span class="icon is-small is-right search-return" (click)="showSearchbox('close')">
                <i class="fa fa-times-circle"></i>
              </span>
            </div>
          </div>


        </div>
        <div class="listing-data">
          <ul *ngIf="chatfileList.length > 0">
            <li *ngFor="let historydata of filterChat(chatfileList); let i = index; let odd = odd">
              <div class="file-item" [ngClass]="{ 'odd': odd }">


                <label class="file-label" (click)="gotoHistory(historydata?.sequence_id)">
                  <ng-container *ngIf="historydata.document_file_name else question_query">
                    {{historydata.document_file_name | slice:0:25 }} ({{ historydata.question_type }})
                  </ng-container>
                  <ng-template #question_query>
                    {{ historydata.question | slice: 0:25 }} ({{ historydata.question_type }})
                  </ng-template>

                  <br />
                  <span class="file-date">
                    {{ historydata.created_at | date: 'MMM d, y, h:mm a' }}
                  </span>
                </label>


                <div class="file-actions">
                  <a class="action-icon" title="View" (click)="viewFile(historydata)">
                    <i class="fa fa-eye"></i>
                  </a>
                  <a class="action-icon" title="Download" (click)="downloadFile(historydata)">
                    <i class="pi pi-download"></i>
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="activeTab === 'audio'">
      <div class="col-md-4 px-0 left-box-shadow tab-view">
        <div class="menu-options level is-marginless searchBox-pad display-flex">
          <div class="level-left">
            <div class="level-item input-search-box">
              <div class="field">
                <p class="control has-icons-left has-icons-right">
                  <input class="input" type="text" placeholder="Search" [(ngModel)]="search"
                    (keyup.enter)="getChatList(0)" placeholder="Search here...">

                  <a class="icon is-small is-left" title="Search">
                    <i class="fa fa-search"></i>
                  </a>
                  <!-- <span class="input-bar"></span> -->
                </p>
              </div>
            </div>
            <div class="level-item" *ngIf="search !==''">
              <span class="icon is-small is-right search-return" (click)="showSearchbox('close')">
                <i class="fa fa-times-circle"></i>
              </span>
            </div>
          </div>


        </div>
        <div class="listing-data">
          <ul *ngIf="chatfileAudioList.length > 0">
            <li *ngFor="let historydata of filterChat(chatfileAudioList); let i = index; let odd = odd">
              <div class="audio-item" [ngClass]="{ 'odd': odd }">


                <div class="audio-info" (click)="gotoHistory(historydata?.sequence_id)">
                  <label class="audio-label">
                    {{ historydata.question | slice: 0:25 }}
                    <br />
                    <span class="audio-date">
                      {{ historydata.created_at | date: 'MMM d, y, h:mm a' }}
                    </span>
                  </label>
                </div>


                <div class="audio-player-wrapper">
                  <i class="fa fa-play-circle audio-play-icon" (click)="showAudio(i)">
                  </i>

                  <div class="audio-wrapper" [ngClass]="{ 'hide': showAudioIndex !== i }">

                    <i class="fa fa-times close-audio" (click)="hideAudio('audio_' + i)">
                    </i>

                    <audio id="audio_{{i}}" [src]="historydata.view_url" class="audio-file-class" controls>
                    </audio>
                  </div>
                </div>


                <div class="audio-actions">
                  <a class="action-icon" title="Download" (click)="downloadFile(historydata)">
                    <i class="pi pi-download"></i>
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
  </div>

</div>
<!--Tab view end-->

<div class="row" *ngIf="!viewControl.hideDocumentView">
  <div class="col">
    <div id="botWrapper">
      <!-- <div class="chat-history-list" [hidden]="hideLeftContent">
      </div> -->
      <div id="chat-content-wrapper">
        <div class="bot-middle-content">
          <div class="position-relative">
            <div class="chat-header">
              <div id="botinput-wrapper">
                <div id="chat-message-enter-box" *ngIf="botTemplateName !== 'normal'">
                  <div id="chatForm">
                    <app-autocomplete #autocomplete (setautoComplete)="setautoComplete($event)"
                      [autoSearchDafaultValue]="autoSearchDafaultValue" [suggestionEnable]="suggestionEnable"
                      [suggestionList]="suggestionList" [placeholderText]="toggle_text"
                      [defaultSelectLanguage]="language"></app-autocomplete>

                    <ng-container *ngIf="voiceActiveSectionDisabled; else voicesection;">
                    </ng-container>
                    <ng-template #voicesection>
                      <div id="voice-message">
                        <ng-container *ngIf="!voiceActiveSectionError; else failure">
                          <ng-container *ngIf="voiceText; else start">
                          </ng-container>
                          <ng-template #start>
                            <ng-container *ngIf="voiceActiveSectionListening; else beginning">
                              <span>Listening...</span>
                            </ng-container>
                            <ng-template #beginning>
                              <span>Start talking...</span>
                            </ng-template>
                          </ng-template>
                        </ng-container>
                        <ng-template #failure>
                          <span>Can't catch your voice</span>
                        </ng-template>
                      </div>
                    </ng-template>

                  </div>
                  <div id="chat-tools-wrapper">
                    <ul id="chat-tools">
                      <li *ngIf="CategoryList && CategoryList.length > 0" class="category-dropdown-wrapper">
                        <p-dropdown id="categorydropdown" [options]="CategoryList" [(ngModel)]="selectedClassList"
                          optionLabel="full_name" placeholder="Select Category"
                          [disabled]="!assistBotService.queryType['library']"
                          (onChange)="dropdownSelectedCategory($event)" class="category-dropdown">
                        </p-dropdown>
                      </li>
                      <li id="upload-doc" *ngIf="userRole === 1 || userRole === 2"
                        (click)="activeFileUpload =!activeFileUpload" class="has-tooltip-bottom"
                        data-tooltip="Upload document and train the LLM" data-bs-toggle="tooltip"
                        data-bs-placement="bottom"><i class="pi pi-cloud-upload"></i></li>
                      <li class="selected-docs-menu">
                        <i class="pi pi-info-circle"></i>
                        <div class="hover-menu" *ngIf="llmService?.selectedDoc_ids?.length" infiniteScroll
                          appInfiniteScroll>
                          <div class="menu-header">Selected Documents ({{llmService?.selectedDoc_ids?.length}})</div>
                          <ul class="menu-list">
                            <li *ngFor="let id of llmService?.selectedDoc_ids">{{ llmService?.selectedDoc_name_map?.[id]
                              || id }}</li>
                          </ul>
                        </div>
                      </li>

                      <li class="has-tooltip-bottom" data-tooltip="Dictation">
                        <i class="fa fa-microphone-slash" [hidden]="microphoneActive"
                          (click)="startVoiceRecognition()"></i>
                        <i class="fa fa-microphone" [hidden]="!microphoneActive" (click)="closeVoiceRecognition()"></i>
                      </li>
                      <!-- <li class="has-tooltip-bottom" data-tooltip="Live Speak Assist">
                        <i class="fa fa-comment-slash"
                          (click)="startLiveSpeakAssist()"></i>
                       </li> -->
                      <li class="has-tooltip-bottom" data-tooltip="Submit Question"> <i class="pi pi-send"
                          [ngClass]="{'disabled':selectedTags.length==0}" (click)="save()"></i>
                      </li>
                    </ul>
                  </div>
                  <div class="btn-group dropup-end">

                  </div>
                </div>
                <p class="disclaimer" style="text-align: center;">
                  <span [innerHTML]="llmService?.Disclaimer"></span>
                </p>
              </div>
            </div>
          </div>

        </div>
        <div id="chat-list-content" appInfiniteScroll infinite-scroll [infiniteScrollDistance]="modalScrollDistance"
          [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false" (scrolled)="fetchDataList('history')"
          (reachedBottom)="onScrollDown()">
          <ng-container [ngSwitch]="botTemplateName">
            <ng-container *ngSwitchCase="'bot'">
              <!-- <div id="chat-list" appInfiniteScroll #scrollcontent *ngIf="chatbotData.length > 0">
                <ng-container *ngFor="let items of chatbotData; let i=index; let even = even; let odd = odd">
                  <app-bot [data]="items" [userDetail]="userDetail" [index]="i" [speakeLanguage]="language"
                    (PingChat)="PingChat($event)" (copyText)="copyText($event)" (Like)="Like($event)"
                    (Dislike)="Dislike($event)"></app-bot>
                </ng-container>
              </div> -->

              <div id="chat-list" #scrollcontent *ngIf="chatbotData.length > 0">
                <ng-container *ngFor="let items of chatbotData; let i=index; let even = even; let odd = odd">
                  <app-bot [data]="items" [userDetail]="userDetail" [index]="i" [speakeLanguage]="language"
                    (PingChat)="PingChat($event)" (copyText)="copyText($event)" (Like)="Like($event)"
                    (Dislike)="Dislike($event)"></app-bot>
                </ng-container>
              </div>

              <div id="chat-list" *ngIf="chatbotData.length==0 && !showPaginateSpinner">
                <!-- <div class="empty-state h-100 px-3 py-3">
                  <p style="text-align: center; width: 100%; height: 100px;  background: #fff; color: #0e0e0e;
    font-size: 1rem;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;"> No Records Found </p>
                </div> -->

              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'normal'">
              <app-botleave-planner>
                <div moreOption>
                  <div class="btn-group dropup-end" style="height:30px;background:#fff;padding:10px;">
                    <span type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="fa-solid fa-ellipsis-vertical"></i>
                    </span>
                    <!-- <ul class="dropdown-menu">
                      <li (click)="ShowTabpanel('history')"><i class="fa fa-history"></i><span>History</span></li>
                      <li (click)="ShowTabpanel('pin')"><i class="fa fa-thumb-tack"></i><span>Pin</span></li>
                      <li (click)="ShowTabpanel('document')"><i class="fa fa-file-text-o"></i><span>Document</span></li>
                      <li (click)="ShowTabpanel('audio')"><i class="fa fa-file-audio-o"></i><span>Audio</span></li>
                      <li (click)="ShowTabpanel('template')"><i class="fa fa-magic"></i><span>Template</span></li>
                    </ul> -->
                  </div>
                </div>
              </app-botleave-planner>

            </ng-container>
            <ng-container *ngSwitchCase="'suggestion'">
              <div id="chat-list" appInfiniteScroll #scrollcontent *ngIf="chatbotData.length > 0">
                <ng-container *ngFor="let items of chatbotData; let i=index; let even = even; let odd = odd">
                  <app-bot [data]="items" [userDetail]="userDetail" [index]="i" [speakeLanguage]="language"
                    (PingChat)="PingChat($event)" (copyText)="copyText($event)" (Like)="Like($event)"
                    (Dislike)="Dislike($event)"></app-bot>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'careinsurance'">
              <div id="chat-list" appInfiniteScroll #scrollcontent *ngIf="chatbotData.length > 0">
                <ng-container *ngFor="let items of chatbotData; let i=index; let even = even; let odd = odd">
                  <app-bot [data]="items" [userDetail]="userDetail" [index]="i" [speakeLanguage]="language"
                    (PingChat)="PingChat($event)" (copyText)="copyText($event)" (Like)="Like($event)"
                    (Dislike)="Dislike($event)"></app-bot>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <app-page-loader *ngIf="showPaginateSpinner"></app-page-loader>
        <!-- <pagination-loader [showFetchLoader]="showPaginateSpinner"></pagination-loader> -->
      </div>
      <div id="right-side-panel" style="display: none;">

        <div id="template-title">
          <span></span>
          <span><a class="button is-small mobile-close-btn" (click)="hidePanel('rightpanel')">
              <i class="fa fa-close"></i>
            </a></span>
        </div>
        <div class="columns">
          <div id="designlist-wrapper">
            <ul id="designlist">
              <ng-container *ngFor="let template of Bot_template_list">
                <ng-container *ngIf="template['bot_name']=='bot' && template['active']">
                  <label>Ask Question</label>
                  <li (click)="changeTemplate('bot')" [class.active]="botTemplateName=='bot'">
                    <img src="../../../assets/images/template-design-2.png">
                  </li>
                </ng-container>
                <ng-container *ngIf="template['bot_name']=='normal' && template['active']">
                  <label>Topic of Interest</label>
                  <li (click)="changeTemplate('normal')" [class.active]="botTemplateName=='normal'">

                    <img src="../../../assets/images/template-design-3.png">
                  </li>
                </ng-container>
                <ng-container *ngIf="template['bot_name']=='suggestion' && template['active']">
                  <label>Topic recommendation</label>
                  <li (click)="changeTemplate('suggestion')" [class.active]="botTemplateName=='suggestion'">

                    <img src="../../../assets/images/template-design-4.png">
                  </li>
                </ng-container>
                <!-- <label>Care Insurance</label>
      <li (click)="changeTemplate('careinsurance')" [class.active]="botTemplateName=='careinsurance'">

        <img  src="../../../assets/images/template-design-2.png">
      </li> -->
              </ng-container>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="container ai-assist-popup py-2" *ngIf="viewControl.hideDocumentView">

  <div class="row">

    <div class="col-8">
      <div class="card" *ngIf="activeTab != 'history'">
        <div class="pop-header d-flex w-100 px-3 py-3">
          <span (click)="disabledVideoPlay()" title="Back"><i class="fa-solid fa-arrow-left"></i></span>
          <span class="pop-title">{{popupTitle}}</span>
        </div>
        <div class="card-content">
          <div class="media" style="width:100%;">

            <div class="content" style="width:100%;">
              <div class="cs-mediaplayer">


                <!-- <div *ngIf="activeTab=='history'" class="pop-content">
                  <p [innerHTML]="selectedReadFile?.bot_answer"></p>
                </div> -->
                <div *ngIf="activeTab=='pin'" class="pop-content">

                  <app-page-loader *ngIf="showPaginateSpinner"></app-page-loader>
                  <ng-container *ngIf="!showPaginateSpinner">
                    <ng-container *ngIf="chatPinList.length==0"><span class="file-item text-center"><b>No records
                          found</b></span></ng-container>
                    <ng-container *ngIf="chatPinList.length > 0">
                      <p [innerHTML]="selectedReadFile?.bot_answer"></p>
                    </ng-container>
                  </ng-container>
                </div>


                <div *ngIf="activeTab=='document'" style="height:80vh;  overflow-y:auto; width:100%;">

                  <app-page-loader *ngIf="showPaginateSpinner"></app-page-loader>
                  <ng-container *ngIf="!showPaginateSpinner">
                    <ng-container *ngIf="chatfileList.length > 0">
                      <!-- Use Microsoft Office Online viewer for Word documents -->
                      <iframe *ngIf="documentViewerType === 'office' && safeOfficeViewerUrl" [src]="safeOfficeViewerUrl"
                        style="width: 100%; height:80vh; border: none; z-index: 999;" title="Document Viewer"
                        allowfullscreen>
                        <p>Your browser does not support viewing Word documents in this viewer.</p>
                      </iframe>
                      <!-- Use Google Docs Viewer for PDFs and other documents -->
                      <ngx-doc-viewer *ngIf="documentViewerType === 'google' && selectedReadFile" class="ngxDocViewer"
                        queryParams="h1=N1" popout-hide="none" viewer="google" googleCheckContentLoaded="true"
                        googleCheckInterval="3000" googleMaxChecks="5" [url]="selectedReadFile"
                        style="width: 100%; height:80vh; z-index: 999;">
                      </ngx-doc-viewer>
                    </ng-container>
                    <ng-container *ngIf="chatfileList.length==0">
                      <span class="file-item text-center"><b>No records found</b></span>
                    </ng-container>

                  </ng-container>

                  <button class="modal-close is-large" aria-label="close" (click)="disabledVideoPlay()"></button>
                </div>

                <div *ngIf="activeTab=='audio'">
                  <app-page-loader *ngIf="showPaginateSpinner"></app-page-loader>
                  <ng-container *ngIf="!showPaginateSpinner">
                    <ng-container *ngIf="chatfileAudioList.length==0"><span class="file-item text-center"><b>No records
                          found</b></span></ng-container>
                    <ng-container *ngIf="chatfileAudioList.length > 0">
                      <div style="height:300px;max-width:50%;margin:3rem auto;">
                        <audio id="audio_{{i}}" [src]="selectedReadFile" class="audio-file-class" controls
                          *ngIf="selectedReadFile"></audio>
                      </div>
                    </ng-container>

                  </ng-container>

                  <button class="modal-close is-large" aria-label="close" (click)="disabledVideoPlay()"></button>
                </div>



                <nav class="pagination is-small" role="navigation" aria-label="pagination">
                  <button class="button is-outlined pagination-previous" [disabled]="prevDisabled"
                    (click)="getPreVideo(currentIndex)">
                    Previous
                  </button>
                  <button class="button is-outlined pagination-next mar-5" [disabled]="nextDisabled"
                    (click)="getNextVideo(currentIndex)">
                    Next
                  </button>
                </nav>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="card events-card">
        <div class="container-fluid">
          <nav class="tabs is-info is-outlined is-fullwidth is-small mb-0">
            <div class="container">
              <ul class="doc-views-tabs" style="font-size: 15px">
                <li class="tab" *ngIf="activeTab=='history'">
                  <a>History</a>
                </li>
                <li class="tab" *ngIf="activeTab=='document'">
                  <a>Document</a>
                </li>
                <li class="tab" *ngIf="activeTab=='audio'">
                  <a>Audio</a>
                </li>
                <li class="tab" *ngIf="activeTab=='pin'">
                  <a>Pin</a>
                </li>
                <a class="delete is-small pull-right" title="Close" (click)="disabledVideoPlay()"></a>
              </ul>
            </div>
          </nav>
        </div>
        <div class="container" style="width:100%">
          <div id="lessons" class="content-tab">
            <div class="menu-options level is-marginless searchBox-pad display-flex pe-2">
              <div class="level-left">
                <div class="level-item input-search-box">
                  <div class="field">
                    <p class="control has-icons-left has-icons-right">
                      <input class="input" type="text" placeholder="Search" [(ngModel)]="search"
                        placeholder="Search here...">

                      <a class="icon is-small is-left" title="Search">
                        <i class="fa fa-search"></i>
                      </a>
                      <!-- <span class="input-bar"></span> -->
                    </p>
                  </div>
                </div>
                <div class="level-item" *ngIf="search !==''">
                  <span class="icon is-small is-right search-return" (click)="showSearchbox('close')">
                    <i class="fa fa-times"></i>
                  </span>
                </div>
              </div>


            </div>
            <div class="card-table">
              <div class="content">



                <ng-container *ngIf="activeTab=='history'">

                  <div class="list-wrapper scroll-bar list-overflow" appInfiniteScroll (reachedBottom)="onScrollDown()"
                    infinite-scroll [infiniteScrollDistance]="modalScrollDistance"
                    [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false"
                    (scrolled)="fetchDataList('history')">
                    <ul class="notification-list">
                      <li class="cursor-pointer pos-relative chat-list"
                        *ngFor="let historydata of filterChat(chatHistoryList); let i = index; let odd = odd">
                        <div class="file-item" [ngClass]="{'active':currentIndex==i}">

                          <!-- Clickable label to go to history -->
                          <span class="file-label" (click)="gotoHistory(historydata?.sequence_id)">
                            {{ historydata.question | slice: 0:50 }}

                          </span>
                          <a class="history-delete" title="Delete" (click)="removeHistory(historydata?.history_id)">
                            <i class="pi pi-trash" aria-hidden="true"></i>
                          </a>
                        </div>
                      </li>
                      <li *ngIf="filterChat(chatHistoryList).length==0 && !showPaginateSpinner">
                        <div class="file-item text-center"><b>No Records Found</b></div>
                      </li>
                    </ul>
                  </div>
                </ng-container>



                <ng-container *ngIf="activeTab=='pin'">
                  <div class="list-wrapper scroll-bar list-overflow" appInfiniteScroll (reachedBottom)="onScrollDown()"
                    infinite-scroll [infiniteScrollDistance]="modalScrollDistance"
                    [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false"
                    (scrolled)="fetchDataList('pin')">
                    <ul class="notification-list">
                      <li class="cursor-pointer pos-relative chat-list"
                        *ngFor="let historydata of filterChat(chatPinList); let i = index; let odd = odd">
                        <div class="file-item" [ngClass]="{'active':currentIndex==i}">

                          <!-- Clickable label to go to history -->
                          <span class="file-label" (click)="viewFile(i)">
                            {{ historydata.question | slice: 0:50 }}

                          </span><a class="pin-delete" title="Delete" (click)="removePin(historydata?.history_id)">
                            <i class="pi pi-trash" aria-hidden="true"></i>
                          </a>
                        </div>
                      </li>
                      <li *ngIf="filterChat(chatPinList).length==0 && !showPaginateSpinner">
                        <div class="file-item text-center"><b>No Records Found</b></div>
                      </li>
                    </ul>
                  </div>
                </ng-container>

                <ng-container *ngIf="activeTab=='document'">
                  <div class="list-wrapper scroll-bar list-overflow" appInfiniteScroll (reachedBottom)="onScrollDown()"
                    infinite-scroll [infiniteScrollDistance]="modalScrollDistance"
                    [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false"
                    (scrolled)="fetchDataList('document')">
                    <ul class="notification-list">
                      <li class="cursor-pointer pos-relative chat-list"
                        *ngFor="let historydata of filterChat(chatfileList); let i = index; let odd = odd">
                        <div class="file-item" [ngClass]="{'active':currentIndex==i}">

                          <!-- Clickable label to go to history -->
                          <span style="width:80%; display: inline-block;" (click)="viewFile(i)">
                            <span class="file-label">
                              <i class="pi" [class]="historydata.question_type=='word' ? 'pi-file-word' : 'pi-file-pdf'"
                                style="margin-right: 15px; font-size: 1.5rem !important;"></i>
                              <!-- {{ historydata.question | slice: 0:50 }} -->

                              <ng-container *ngIf="historydata.document_file_name else question_query">
                                {{historydata.document_file_name | slice:0:25 }}
                              </ng-container>
                              <ng-template #question_query>
                                {{ historydata.question | slice: 0:25 }}
                              </ng-template>
                              <!-- ({{ historydata.question_type }}) -->


                            </span><span class="file-date">
                              {{ historydata.createdAt | date: 'MMM d, y, h:mm a' }}

                            </span>&nbsp;

                          </span>
                          <a class="history-delete" title="Delete" (click)="removeDocument(historydata?.history_id)">
                            <i class="pi pi-trash" aria-hidden="true"></i>
                          </a>&nbsp;&nbsp;&nbsp;
                          <a class="action-icon" title="Download" (click)="downloadFile(historydata)">
                            <i class="pi pi-download"></i>
                          </a>
                        </div>
                      </li>
                      <li *ngIf="filterChat(chatfileList).length==0 && !showPaginateSpinner">
                        <div class="file-item text-center"><b>No Records Found</b></div>
                      </li>
                    </ul>
                  </div>
                </ng-container>
                <ng-container *ngIf="activeTab=='audio'">
                  <div class="list-wrapper scroll-bar list-overflow" appInfiniteScroll (reachedBottom)="onScrollDown()"
                    infinite-scroll [infiniteScrollDistance]="modalScrollDistance"
                    [infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false"
                    (scrolled)="fetchDataList('audio')">
                    <ul class="notification-list">
                      <li class="cursor-pointer pos-relative chat-list"
                        *ngFor="let historydata of filterChat(chatfileAudioList); let i = index; let odd = odd">
                        <div class="file-item" [ngClass]="{'active':currentIndex==i}">

                          <!-- Clickable label to go to history -->
                          <span style="width:80%; display: inline-block;" (click)="viewFile(i)">
                            <span class="file-label">
                              <i class="fa fa-file-audio-o"></i>&nbsp; {{ historydata.question | slice: 0:50 }}


                            </span>
                            <span class="file-date">
                              {{ historydata.created_at | date: 'MMM d, y, h:mm a' }}
                            </span>&nbsp;

                          </span>
                          <a class="history-delete" title="Delete" (click)="removeAudio(historydata?.history_id)">
                            <i class="pi pi-trash" aria-hidden="true"></i>
                          </a>&nbsp;&nbsp;&nbsp;
                          <a class="action-icon" title="Download" (click)="downloadFile(historydata)">
                            <i class="pi pi-download"></i>
                          </a>
                        </div>
                      </li>
                      <li *ngIf="filterChat(chatfileAudioList).length==0 && !showPaginateSpinner">
                        <div class="file-item text-center"><b>No Records Found</b></div>
                      </li>
                    </ul>
                  </div>
                </ng-container>


              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="activeFileUpload">
  <div class="modal fade show policy-upload">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Upload Document</h5>
          <span class="pull-right" (click)="closeUploadModal()"><i class="fa-solid fa-times"></i></span>
        </div>
        <div class="modal-body">
          <form [formGroup]="uploadFileForm">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <!-- Modern Dropzone Upload Section -->
                  <div class="dropzone-upload-wrapper">
                    <!-- Dropzone - Always visible -->
                    <div class="dropzone" [class.dragging]="isDragging" [class.has-file]="upLoadedFileList.length > 0"
                      (drop)="onDrop($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                      (click)="elibraryFileInput.click()">
                      <input type="file" (change)="chooseUploadFile($event)" #elibraryFileInput
                        accept=".pdf, .doc, .docx, .txt, .odt" id="rfpFileInput" />
                      <label for="rfpFileInput" class="dropzone-label">
                        <i class="pi pi-cloud-upload icon"></i>
                        <div class="text">
                          <strong>Drag & drop file here</strong> or click to browse
                        </div>
                        <small>Please upload a document in Q&A format. Only PDF, DOC, DOCX, ODT, and TXT files are
                          supported.</small>
                      </label>
                    </div>

                    <!-- Selected File Display - White Card -->
                    <div class="selected-file-display" *ngIf="upLoadedFileList.length > 0">
                      <div class="file-item-card">
                        <div class="file-icon-wrapper">
                          <i class="pi" [class]="getFileIcon(upLoadedFileList[0].mimeType)"></i>
                        </div>
                        <div class="file-details">
                          <div class="selected-file-name">{{ upLoadedFileList[0].name }}</div>
                          <div class="file-size-text">{{ formatFileSize(upLoadedFileList[0].size) }}</div>
                        </div>
                        <button class="delete-btn" aria-label="Delete" (click)="removeUploadFile(upLoadedFileList)">
                          <i class="pi pi-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="button mar-0-5 is-small" (click)="closeUploadModal()"
            [disabled]="showBtnSpinner">
            Cancel
          </button>
          <a class="button is-link is-loading is-small" style="min-width: 100px" *ngIf="showBtnSpinner"></a>
          <button *ngIf="!showBtnSpinner" type="button" class="button mar-0-5 is-small is-link"
            [disabled]="upLoadedFileList.length === 0" (click)="uploadLLM()">
            Upload
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
